import { put, call, select } from "redux-saga/effects";

import { BFFAgent } from '../../../../common/BFFAgent';
import {
  GESTION_OPERATIVA_GET_SALE_FAILURE,
  GESTION_OPERATIVA_GET_SALE_SUCCESS,
  GESTION_OPERATIVA_GET_SALE_BEGIN,
} from '../constants';

export function* getSaleSaga({ data: { id, queryData, perfil, editMode = false } }) {
  try {
    yield put({ type: GESTION_OPERATIVA_GET_SALE_BEGIN })
    const sale = yield call(BFFAgent.Sales.getSale, id, queryData, perfil, editMode);
    const permissions = yield select(
      state => state.common?.user?.permissions?.Active_functions
    )
    const takingCars = []

    for (const car of sale.Taking_cars || []) {
      let updatedCar = {
        ...car,
        updatedTakePrice: car.updatedTakePrice ? Number(car.updatedTakePrice) : car.updatedTakePrice,
        updatedTakePriceWasModified: Boolean(Number(car.updatedTakePrice)),
      }

      if (car.license_plate) {
        const peritajeResp = yield call(BFFAgent.Peritador.getPeritaje, car.license_plate, false, true)
        const { peritaje, peritajeQuote } = peritajeResp || {}

        if (peritaje && peritajeQuote) {
          updatedCar = {
            ...updatedCar,
            appraisal_approved: peritajeQuote.appraisal_approved,
          }
        }
      }

      takingCars.push(updatedCar)
    }
    
    yield put({
      type: GESTION_OPERATIVA_GET_SALE_SUCCESS,
      data: { sale, takingCars, permissions },
    })

  } catch (err) {
    yield put({
      type: GESTION_OPERATIVA_GET_SALE_FAILURE,
      data: { error: err },
    })
  }

}